import React, { useState } from 'react';
import apiClient from '../utils/apiClient';
import { SERVER_BASE } from '../config/server';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';


const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Retrieve query parameters
  const redirect = searchParams.get('redirect') || '/dashboard';
  const type = searchParams.get('type');
  const decodeRedirect=decodeURIComponent(redirect)
const substringDecoded=decodeRedirect.substring(11,)  



 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  try {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'info',
      title: 'Please wait...',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });

    const response = await apiClient.post(`${SERVER_BASE}/login`, { email, password });

    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: response.data.message,
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
    });

    const role = response.data.role;
    localStorage.setItem('email', response.data.email);
    localStorage.setItem('username', response.data.username);
    localStorage.setItem('role', role);
    localStorage.setItem('code', response.data.code);
    localStorage.setItem('name', response.data.name);
    localStorage.setItem('token', response.data.token);
    localStorage.setItem('badgeId', response.data.badgeId);
    localStorage.setItem('pin', response.data.pin);
    localStorage.setItem('sewadarOf', response.data.sewadarOf);
    localStorage.setItem('sewadarId', response.data.sewadarId);

    // Delay to ensure toast is visible
    await new Promise((resolve) => setTimeout(resolve, 1500));

    if (response.data.isFirst) {
      navigate('/setPassword');
    } else {
      if (type === 'inventory' && redirect && response.data.token) {
        navigate(decodeRedirect);
      } else if (type === 'gatePass' && redirect && response.data.token) {
        navigate(decodeRedirect);
      } else if (type === 'challan' && redirect && response.data.token) {
        navigate(decodeRedirect);
      } else {
        navigate('/dashboard');
      }
    }
  } catch (error) {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'error',
      title: error?.response?.data?.message || 'An unexpected error occurred',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });
    console.error(error);
  } finally {
    setLoading(false);
  }
};


  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card shadow p-4" style={{ width: '400px', height: 'auto' }}>
        <h2 className="text-center mb-4">Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email/Username</label>
            <input
              type="text"
              className="form-control"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-3 position-relative">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              type={showPassword ? 'text' : 'password'}
              className="form-control"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span
              className="position-absolute"
              style={{ right: '10px', top: '73%', transform: 'translateY(-50%)', cursor: 'pointer' }}
              onClick={toggleShowPassword}
            >
              <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
            </span>
          </div>
          <div className="d-grid mb-3">
            <button type="submit" className="btn btn-success" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
            <div className="text-center">
        <Link to="/forgotPassword" style={{ color: '#198754',textDecoration:'none' }}>Forgot Password?</Link>
        </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
